// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"63463005","305":"a17e0c2a","336":"bf782c65","387":"9c107e61","899":"54edd27d"}[chunkId] + ".chunk.js";
};